/* eslint-disable */
/// This file is auto generated - do not edit manually
export const CertificationSeeAll = 'Website.Product.Tabs.CertificationSeeAll';
export const ReadAboutTextAndLink = 'Website.Product.Tabs.ReadAboutTextAndLink';
export const CustomMediaContentButton = 'Website.Product.Tabs.CustomMediaContentButton';
